import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ManageArticles = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("No token found. Access denied.");
        return;
      }
      const response = await axios.get("https://demo-two.keytime.sa/api/articles", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("The articles are as follow: ", response.data);
      setArticles(response.data);
    } catch (error) {
      setError("Error fetching articles");
      console.error("Error fetching articles:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteArticle = async (id) => {
    console.log("id: ", id);
    const token = localStorage.getItem("token");
    try {
      await axios.delete(`https://demo-two.keytime.sa/api/articles/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setArticles((prevArticles) =>
        prevArticles.filter((article) => article.id !== id)
      );
    } catch (error) {
      setError("Error deleting article");
      console.error("Error deleting article:", error);
    }
  };

  const editArticle = (article) => {
    if (!article || !article.article_id) {
      console.error("🚨 Cannot edit: Service data is incomplete!");
      setError("Invalid service data. Unable to edit.");
      return;
    }
  
    console.log(`📡 Editing service with ID: ${article.article_id}`);
   
    navigate("/dashboard/addarticle", { state: { article } });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="w-[80%] flex flex-col justify-center items-center mx-auto gap-10">
      <h2 className="text-2xl py-5">Manage Articles</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map((article) => (
          <div
            key={article.id}
            className="border p-4 rounded-lg shadow-md">
     
            <div className="flex flex-col items-center">
              <img
                src={`/serviceImages/${article.thumbnail}`}
                alt="Service"
                className="w-32 h-32 object-cover rounded"
              />
               <div className="mt-3 text-center">
              <h3>{article.name}</h3>
              <div>
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded"
                  onClick={() => deleteArticle(article.id)}
                >
                  Delete
                </button>
                <button
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                  onClick={() => editArticle(article)}
                >
                  Edit
                </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageArticles;
